import { render } from "./MouvementPages.vue?vue&type=template&id=661fb20a"
import script from "./MouvementPages.vue?vue&type=script&lang=js"
export * from "./MouvementPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__